import type { ObjectMetadata } from '@olytic/foundation';

import { formatMoney, formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDate, asDateTime, asLabel, column, field, lastModifiedByField, lookup, type Row, related, show, text } from './kit';

const def = OBJECT_DEFS['invoice-runs'];
const money = show(formatMoney);

/** One pass of invoice generation. Rationale: invoice-runs.md. */
export const invoiceRuns: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Invoice run',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('through_date', 'Through', { format: asDate }),
    field('status', 'Status', { format: asLabel }),
    field('invoice_count', 'Invoices', { format: show((v) => formatNumber(v)) }),
    field('total', 'Total', { format: money }),
    field('run_at', 'Run', { format: asDateTime }),
    field('created_by_name', 'Run by'),
    field('notes', 'Notes', { wide: true }),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['through_date', 'status', 'invoice_count', 'total', 'run_at', 'created_by_name'] },
    { key: 'notes', label: 'Notes', fields: ['notes'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['last_modified_by_name'] },
  ],
  related: [
    related('invoices', 'Invoices', 'invoices', [
      column('name', 'Invoice', { primary: true }),
      column('billing_account_name', 'Billing Account', { link: lookup('billing-accounts', 'billing_account_id') }),
      column('invoice_date', 'Date', { format: asDate }),
      column('status', 'Status', { format: asLabel }),
      column('total', 'Total', { format: money, align: 'right' }),
    ]),
  ],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'created_by_name'],
};
